import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { TippyV2 } from "@/react/components/shared/TippyV2";
import { Button } from "@circle-react-uikit/Button";

export const SnippetButtons = ({
  isEditing,
  onCancel,
  onEdit,
  onDelete,
}: {
  isEditing: boolean;
  onCancel: () => void;
  onEdit: () => void;
  onDelete: () => void;
}) => {
  const form = useFormContext();

  return (
    <div className="text-dark flex gap-3">
      {isEditing ? (
        <>
          <Button
            variant="secondary"
            onClick={() => {
              form.reset();
              onCancel();
            }}
          >
            {t("settings.community_bot.knowledge.custom.preview_drawer.cancel")}
          </Button>
          <Button variant="circle" type="submit">
            {t("settings.community_bot.knowledge.custom.preview_drawer.save")}
          </Button>
        </>
      ) : (
        <>
          <TippyV2
            arrow={false}
            content={t(
              "settings.community_bot.knowledge.custom.preview_drawer.edit",
            )}
          >
            <Button
              type="button"
              variant="secondary-light"
              className="inline !p-1.5"
              onClick={event => {
                onEdit();
                event.stopPropagation();
                event.preventDefault();
              }}
            >
              <Icon size={20} type="20-snippet-preview-pencil" />
            </Button>
          </TippyV2>
          <TippyV2
            arrow={false}
            content={t(
              "settings.community_bot.knowledge.custom.preview_drawer.delete",
            )}
          >
            <Button
              variant="secondary-light"
              className="inline !p-1.5"
              onClick={event => {
                onDelete();
                event.stopPropagation();
                event.preventDefault();
              }}
            >
              <Icon size={20} type="20-snippet-preview-trash" />
            </Button>
          </TippyV2>
        </>
      )}
    </div>
  );
};
